export class BOIcd10ToIcd11{
    id:number;
    codeIcd10:string;
    titleIcd10English:string;
    codeIcd11:string;
    titleIcd11English:string;

    titleIcd10Spanish:string;
    titleIcd11Spanish:string;
}
